import { Form } from 'antd';
import { useAppDispatch, useAppSelector } from '../../../../lib/store/hooks';
import { ArrangeFormItem } from '../../../../lib/models/Arrange';
import { TableSortOrder } from '../../../../lib/utils/constants';
import { closeModalAfterApply } from '../../../../features/table/helpers/closeModalAfterApply';
import { TableHeaderCell } from '../../../../components/Table/TableHeaderCell/TableHeaderCell';
import { SortPopup } from '../../../../features/table/components/popups/SortPopup';
import { getArrangesInitialValues } from '../../../../lib/utils/arranges-helpers';
import { ReactNode } from 'react';
import { RULES_COLUMN } from '../../../../lib/types/ruleBuilder';
import { setSorting } from '../../../../lib/store/slices/ruleBuilder';

type Props = {
  title: string | ReactNode;
  arrangedId: RULES_COLUMN;
};

export const RulesDataHeaderCell = ({ arrangedId, title }: Props) => {
  const { arrangeId, sorting } = useAppSelector(({ ruleBuilder }) => ruleBuilder);
  const isActiveArrange = arrangeId === arrangedId;
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();

  const applyArranges = () => {
    const sortOrder = form.getFieldValue(ArrangeFormItem.SORT_ORDER);
    const sortingForChange = {
      arrangeId: arrangedId,
      sorting: {
        sortOrder: sortOrder as TableSortOrder,
        sortFieldName: arrangedId,
        withSorting: true,
      },
    };
    dispatch(setSorting(sortingForChange));
    closeModalAfterApply(arrangedId);
  };

  const headerCellProps = {
    title,
    sortOrder: sorting.sortOrder,
    isActiveArrange,
    form,
    applyArranges,
    arrangedId,
  };

  return (
    <TableHeaderCell {...headerCellProps}>
      <SortPopup
        initialValues={getArrangesInitialValues(form)}
        form={form}
        onFinish={applyArranges}
        isActiveArrange={isActiveArrange}
      />
    </TableHeaderCell>
  );
};
